exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".POICrossingNotificationConfigForm {\r\n\twidth: 600px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm > div:not(:last-child) {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm .CheckboxContainer label {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm label.Title {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n\tdisplay: block;\r\n\tcolor: #AAA;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.POICrossingNotificationConfigForm .Checkbox {\r\n\tmargin-right: 5px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/POICrossingNotifications/POICrossingNotificationConfigForm/POICrossingNotificationConfigForm.css
// module id = 722
// module chunks = 0